'use client';

import { createContext, useContext } from 'react';

// Exact prefixes SmartEdit uses on <body>
const SMARTEDIT_PREFIXES = ['smartedit-page-uid-', 'smartedit-page-uuid-', 'smartedit-catalog-version-uuid-'] as const;

/**
 * Toggle SmartEdit body classes
 */
const toggleBodyClasses = (enable: boolean, uid?: string, uuid?: string, catalogVersion?: string) => {
  if (typeof document === 'undefined' || !document.body) return;

  const bodyClassList = document.body.classList;
  const toRemove: string[] = [];

  (Array.from(bodyClassList) as string[]).forEach((cls: string) => {
    if (SMARTEDIT_PREFIXES.some((p) => cls.startsWith(p))) {
      toRemove.push(cls);
    }
  });
  if (toRemove.length) bodyClassList.remove(...toRemove);

  if (enable) {
    const toAdd: string[] = [];
    if (uid) toAdd.push(`smartedit-page-uid-${uid}`);
    if (uuid) toAdd.push(`smartedit-page-uuid-${uuid}`);
    if (catalogVersion) toAdd.push(`smartedit-catalog-version-uuid-${catalogVersion}`);
    if (toAdd.length) bodyClassList.add(...toAdd);
  }
};

export const SmartEditContext = createContext<{ catalogVersionUuid?: string }>({});

/**
 * cmsTicketId is accepted as a parameter (read by the caller via useCmsTicketId)
 * so that this hook stays free of useSearchParams / usePathname and is trivially
 * testable without router mocks.
 */
const useSmartEdit = (cmsTicketId?: string) => {
  const isSmartEditEnabled = !!cmsTicketId;
  const catalogVersionUuid = useContext(SmartEditContext).catalogVersionUuid;

  return {
    catalogVersionUuid,
    isSmartEditEnabled,
    toggleBodyClasses,
  };
};

export default useSmartEdit;
